// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonPage_wrapper__tpilv","buttons":"ButtonPage_buttons__9Dgun"};